angular.module('iw.frontyard.signup')
    .directive('iwBlurContainer', function ($parse) {
        return {
            restrict: 'A',
            controller: function ($scope, $attrs) {
                var iwBlurContainer = this;
                iwBlurContainer.childElements = [];

                iwBlurContainer.register = function (childElement) {
                    iwBlurContainer.childElements.push(childElement[0]);

                    childElement.on('blur', function (event) {
                        if (iwBlurContainer.childElements.indexOf(event.relatedTarget) === -1) {
                            $scope.$evalAsync(function(){
                                $parse($attrs.iwBlurContainer)($scope);
                            });
                        }
                    });
                };

            }
        };
    });